"use client";
import {
  __async
} from "../../../chunk-MMUBH76A.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import {
  CpslButton,
  CpslCodeInput,
  CpslDivider,
  CpslIcon,
  CpslQrCode,
  CpslSpinner,
  CpslText
} from "@getpara/react-components";
import { useEffect, useRef, useState } from "react";
import { useModalStore } from "../../stores/index.js";
import { Heading, QRContainer, FilledDisabledInput, StepContainer, InnerStepContainer } from "../common.js";
import { ModalStep } from "../../utils/steps.js";
import { styled } from "styled-components";
import { useCopyToClipboard } from "@getpara/react-common";
import { useInternalClient } from "../../../provider/hooks/utils/useInternalClient.js";
const Setup2FAStep = ({ onClose }) => {
  const isLogin = useModalStore((state) => state.isLogin());
  const setStep = useModalStore((state) => state.setStep);
  const para = useInternalClient();
  const isVerifying = useModalStore((state) => state.step === ModalStep.VERIFY_2FA);
  const [copied, copy] = useCopyToClipboard();
  const inputRef = useRef(null);
  const [qrCodeValue, setQrCodeValue] = useState(null);
  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState("");
  const [isVerifyingCode, setIsVerifyingCode] = useState(false);
  const params = qrCodeValue ? new URL(qrCodeValue).searchParams : void 0;
  const secret = params == null ? void 0 : params.get("secret");
  useEffect(() => {
    function fetchOtpAuthUrl() {
      return __async(this, null, function* () {
        try {
          const { uri } = yield para.setup2FA();
          setQrCodeValue(uri);
        } catch (error) {
          console.error("Error fetching OTPAuth URL:", error);
        }
      });
    }
    fetchOtpAuthUrl();
  }, []);
  useEffect(() => {
    setTimeout(() => {
      var _a, _b, _c;
      (_c = (_b = (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.shadowRoot.querySelectorAll("input")) == null ? void 0 : _b[0]) == null ? void 0 : _c.focus();
    }, 10);
  }, [isVerifying]);
  useEffect(() => {
    if (code.length === 6) {
      handleSubmitCode();
    }
  }, [code]);
  const handleNext = () => {
    setStep(ModalStep.VERIFY_2FA);
  };
  const handleSkip = () => {
    if (isLogin) {
      setStep(ModalStep.LOGIN_DONE);
    } else {
      onClose();
    }
  };
  const handleCodeInput = (e) => {
    if (codeError) {
      setCodeError("");
    }
    setCode(e.detail.value.trim());
  };
  const handleSubmitCode = () => __async(void 0, null, function* () {
    setIsVerifyingCode(true);
    if (code.length === 6 && /^\d+$/.test(code)) {
      try {
        yield para.enable2FA({ verificationCode: code });
        setStep(ModalStep.TWO_FACTOR_DONE);
      } catch (e) {
        setCodeError("Incorrect Code");
      }
    } else {
      setCodeError("Incorrect Code");
    }
    setIsVerifyingCode(false);
  });
  const handleCopy = () => {
    copy(secret);
  };
  return /* @__PURE__ */ jsxs(StepContainer, { children: [
    /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
      /* @__PURE__ */ jsx(Heading, { variant: "headingS", weight: "bold", children: "Turn on Two-Factor authentication" }),
      isVerifying && /* @__PURE__ */ jsx(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Please enter the code from your authenticator app." })
    ] }),
    /* @__PURE__ */ jsx(InnerStepContainer, { children: isVerifying ? /* @__PURE__ */ jsx(Fragment, { children: isVerifyingCode ? /* @__PURE__ */ jsx(CpslSpinner, {}) : /* @__PURE__ */ jsx(
      "form",
      {
        onSubmit: (e) => __async(void 0, null, function* () {
          e.preventDefault();
          yield handleSubmitCode();
        }),
        children: /* @__PURE__ */ jsx(
          StyledCodeInput,
          {
            ref: inputRef,
            code,
            onCpslInput: handleCodeInput,
            errorText: codeError,
            length: 6,
            onKeyDown: (e) => __async(void 0, null, function* () {
              return e.key === "Enter" && (yield handleSubmitCode());
            })
          }
        )
      }
    ) }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(CpslText, { variant: "bodyS", color: "secondary", weight: "medium", children: "Scan with your preferred authenticator app." }),
      /* @__PURE__ */ jsx(QRContainer, { children: !qrCodeValue ? /* @__PURE__ */ jsx(CpslSpinner, { size: 100 }) : /* @__PURE__ */ jsx(CpslQrCode, { url: qrCodeValue }) })
    ] }) }),
    !isVerifying && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(InnerStepContainer, { children: /* @__PURE__ */ jsx(CpslDivider, { children: "or enter the code manually" }) }),
      /* @__PURE__ */ jsx(InnerStepContainer, { children: /* @__PURE__ */ jsx(FilledDisabledInput, { disabled: true, value: secret, noAutoDisable: true, children: /* @__PURE__ */ jsx(CpslButton, { slot: "end", variant: "ghost", onClick: handleCopy, children: /* @__PURE__ */ jsx(CpslIcon, { icon: copied ? "check" : "copy" }) }) }) }),
      /* @__PURE__ */ jsxs(InnerStepContainer, { children: [
        /* @__PURE__ */ jsx(CpslButton, { fullWidth: true, onClick: handleNext, children: "Continue" }),
        /* @__PURE__ */ jsx(SkipButton, { variant: "ghost", onClick: handleSkip, children: "Skip" })
      ] })
    ] })
  ] });
};
const StyledCodeInput = styled(CpslCodeInput)`
  align-self: center;
`;
const SkipButton = styled(CpslButton)`
  margin-top: 8px;
  text-decoration: underline;
`;
export {
  Setup2FAStep
};
